var map = {
	"./de.json": 384,
	"./en.json": 385,
	"./es.json": 386,
	"./fr.json": 387,
	"./it.json": 388,
	"./skins/default.en.json": 667,
	"./skins/education.de.json": 668,
	"./skins/education.en.json": 669,
	"./skins/education.es.json": 670,
	"./skins/education.fr.json": 671,
	"./skins/education.it.json": 672,
	"./skins/museum.de.json": 673,
	"./skins/museum.en.json": 674,
	"./skins/museum.es.json": 675,
	"./skins/museum.fr.json": 676,
	"./skins/museum.it.json": 677,
	"./tenants/ancot.it.json": 678,
	"./tenants/csp.en.json": 679,
	"./tenants/csp.it.json": 680,
	"./tenants/ekom.it.json": 681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 666;